import { ScriptService } from './../../../../services/cms/script.service';
//Angular
import { Component, OnInit, ViewContainerRef, ChangeDetectionStrategy, ViewEncapsulation, Compiler, Input, Inject, Renderer } from "@angular/core";

//Services
import { ClientAreaService } from "./../../../../services/settings/client-area.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { Router } from "@angular/router";
import { RoutesService } from "./../../../../services/core/routes.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";

//Models
import { ClientAreaOrderDetails } from "./../../../../models/settings/client-area";
import { CookieService } from "../../../../services/core/cookie/cookie.service";
import { ApiService } from "../../../../services/core/api.service";
import { MessagesService } from "../../../../services/core/messages.service";
import { Mappings } from "../../../../shared/mapping";
import { TranslateService } from "@ngx-translate/core";
import { SeoService } from "../../../../services/core/seo.service";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from "@angular/platform-browser";
import { CurrencyService } from '../../../../services/cms/currency.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})
export class ClientAreaInvoicesComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private authService: AuthService,
            private router: Router,
            private clientAreaService: ClientAreaService,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }
        let ClientAreaInvoicesListTemplate: any;

        let userId = this.authService.GetUserId();
        let showAll: string = "-1"
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        let invoicesSub = this.clientAreaService.getClientAreaInvoicesList(userId, showAll, showAll, showAll).subscribe(result => {

            ClientAreaInvoicesListTemplate = result;

            if (ClientAreaInvoicesListTemplate.isActiveInvoicesModule) {
                // Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(ClientAreaInvoicesListTemplate,header);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                let subComponent = this.redirectToHomepage(ClientAreaInvoicesListTemplate);
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }

        })

        this.subManager.add(invoicesSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    //if invoices module is not active, then redirect to homepage
    private redirectToHomepage(ClientAreaInvoicesListTemplate: any) {
        @Component({
            template: ClientAreaInvoicesListTemplate.TemplateHtml
        })

        class ChildComponent implements OnInit {

            constructor
                (private router: Router) { }

            ngOnInit(): void {
                this.router.navigate([""]);
            }
        }

        return ChildComponent;
    }

    private createSubComponent(ClientAreaInvoicesListTemplate: any,header: any) {

        @Component({
            template: ClientAreaInvoicesListTemplate.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    @Inject('CookieService') private cookie: CookieService,
                    private clientAreaService: ClientAreaService,
                    private router: Router,
                    private authService: AuthService,
                    private routesService: RoutesService,
                    private apiService: ApiService,
                    private messagesService: MessagesService,
                    private mappings: Mappings,
                    public currency: CurrencyService,
                    private languageService: LanguageService,
                    private translateService: TranslateService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private seoService: SeoService,
                    private breadcrumbsService: BreadcrumbsService,
                    private scriptService: ScriptService
                ) { }

            private pageIsInit: boolean = false;

            public rows: Array<any> = [];

            public columns: Array<any> = [];

            //translating of header columns titles
            translateTableColumnTitle(columnTitle) {
                let translation = this.translateService.get(columnTitle)["value"];
                return translation;
            }

            @Input() clientModel: Array<ClientAreaOrderDetails>;

            //filter fields
            private documentTypeSelect: string = "-1";
            private orderNumber: string = "";
            private invoiceNumber: string = "";

            private lang: string = this.languageService.getLongLang();
            private shortLang: string = this.languageService.getShortLang();

            private load: boolean = true;

           footerData: any = ClientAreaInvoicesListTemplate.footerData;
           headerData: any = header;

            //Routes for menu-tabs
            private areaClientiHome: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
            private areaClientiOrdini: string[] = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
            private areaChangeProfile: string[] = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
            private areaClientiInvoices: string[] = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
            private areaClientiCatalogoRiservato: string[] = this.routesService.getRoutePath('RESERVED - CATALOG');
            private isActiveInvoicesModule: boolean = ClientAreaInvoicesListTemplate.isActiveInvoicesModule;
            private isCatalogPrivateActive: boolean = ClientAreaInvoicesListTemplate.isCatalogPrivateActive;
            private breadcrumbs: Breadcrumbs[] = ClientAreaInvoicesListTemplate.BreadcrumbsInfo;

            private currentLang: any;
            italianLang = {
                "sProcessing": "Attendere...",
                "sLengthMenu": "Visualizza _MENU_ record per pagina",
                "sZeroRecords": "Niente trovato",
                "sInfo": "Mostra _START_ a _END_ di _TOTAL_ record",
                "sInfoEmpty": "Non ci sono record",
                "sInfoFiltered": "(filtrato da _MAX_ record totali)",
                "sInfoPostFix": "",
                "sUrl": "",
                "oPaginate": {
                    "sPrevious": "«",
                    "sNext": "»"
                }
            }

            englishLang = {
                "oPaginate": {
                    "sPrevious": "«",
                    "sNext": "»"
                }
            }

            subManager = new Subscription();

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                this.columns = [
                    { title: this.translateTableColumnTitle("OrderNumberInvoice") },
                    { title: this.translateTableColumnTitle("InvoiceNumberInvoice") },
                    { title: this.translateTableColumnTitle("CreationDateInvoice") },
                    { title: this.translateTableColumnTitle("TotalPriceInvoice") },
                    { title: this.translateTableColumnTitle("DocumentTypeInvoice") },
                    { title: this.translateTableColumnTitle("Download") }
                ];

                //getting of Datatable data
                this.rows = ClientAreaInvoicesListTemplate.ClientAreaInvoicesList;
                this.load = false;
              
            }

            ngAfterViewChecked() {

                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                if (this.shortLang == 'it') {
                    this.currentLang = this.italianLang;
                }
                else {
                    this.currentLang = this.englishLang;
                }

                //initialization of datatable
                $('#datatable').DataTable({
                    searching: false,
                    ordering: false,
                    sDom: 'Rlfrtlip',
                    oLanguage: this.currentLang
                });

                //hiding of first 'per page' section, because we added it on the bottom of the table
                $('.dataTables_length').not(':eq(1)').hide();

                this.pageIsInit = true;
            }

            getInvoicesList(userId: string, orderNumber: string, invoiceNumber: string, documentType: string) {
                let showAll = "-1";
                this.load = true;
                let invoicesSub = this.clientAreaService.getClientAreaInvoicesList(userId, orderNumber, invoiceNumber, documentType)
                    .subscribe(result => {
                        this.rows = result.ClientAreaInvoicesList;
                        this.load = false;

                        this.resetTable(this.rows);
                    })

                this.subManager.add(invoicesSub);
            }

            //destroying of current context of table and creating a new one with new data
            resetTable(tableData) {
                $('#datatable').DataTable().destroy();
                let currentLang = this.currentLang;
                setTimeout(function () {
                    $('#datatable').DataTable
                        (
                            {
                                data: this.rows,
                                searching: false,
                                ordering: false,
                                sDom: 'Rlfrtlip',
                                oLanguage: currentLang
                            }
                        );
                }, 0);

                setTimeout(function () { $('.dataTables_length').not(':eq(1)').hide() }, 0);
            }

            resetFilter() {
                this.rows = ClientAreaInvoicesListTemplate.ClientAreaInvoicesList;
                this.orderNumber = "";
                this.invoiceNumber = "";
                this.documentTypeSelect = "-1";
                this.resetTable(this.rows);
            }

            filterInvoicesList() {
                let showAll = "-1";
                let userId = this.authService.GetUserId();

                //checking if inputs for filtering are empty, if they are, set them to "show all", which is '-1' value
                let filterOrderNumber = this.orderNumber != "" ? this.orderNumber : showAll;
                let filterInvoiceNumber = this.invoiceNumber != "" ? this.invoiceNumber : showAll;

                //if all fields are empty, then don't send request to a server, but set rows value to start
                if (filterOrderNumber == showAll && filterInvoiceNumber == showAll && this.documentTypeSelect == showAll) {
                    this.resetFilter();
                }
                else {
                    this.getInvoicesList(userId, filterOrderNumber, filterInvoiceNumber, this.documentTypeSelect);
                }
            }
            getClassforMenuClientArea()
            {
              let result;
              if(this.isActiveInvoicesModule&&this.isCatalogPrivateActive)
              {
                result="col-md-3 col-sm-3"
              }
              else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                result = "col-md-3 col-sm-3"
              }
              else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                result = "col-md-4 col-sm-4"
              }
              return result
            }
            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/client-area/sys/client-area-invoices.component.ts